// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__tYeQB","orders__container":"Orders_orders__container__p2OdT"};